import React from 'react';

import './WpDivider.scss';

type Padding = 0 | 4 | 8 | 12 | 16 | 20 | 24 | 28 | 32;

export interface Props {
  text?: string;
  padding?: Padding;
}

const WpDivider: React.FC<Props> = ({ text, padding = 8 }: Props) => {
  const classNamePrefix = 'WpDivider';
  return (
    <div className={classNamePrefix} style={{ padding: `${padding}px 0` }}>
      <div className={`${classNamePrefix}__divider`} />
      {text && (
        <>
          <span className={`${classNamePrefix}__text`}>{text}</span>
          <div className={`${classNamePrefix}__divider`} />
        </>
      )}
    </div>
  );
};

export default WpDivider;
